// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__z2iFE","translucent":"Header_translucent__Ddd7U","content":"Header_content__j5oy7","logo":"Header_logo__siCrM"};